import React, {useEffect, useState} from 'react';

// tremor
import { Callout, Card, Text, Metric } from "@tremor/react";

// icons
import { IoWarning } from "react-icons/io5";

const ErrorMessage = (props) => {

    return (
            <Callout
                className="h-12 mt-4"
                title={props.title}
                icon={IoWarning}
                color="rose"
                text={props.error}
            >
            </Callout>
    );
};

export default ErrorMessage;
